import React from 'react';
import { useTranslation } from 'react-i18next';
import { AtoZTheme, StencilProvider } from '@amzn/atoz-web';
// AtoZPirates-525
//
// The z-indexes for various components defined by Bootstrap V3 (which is used by ESSP) differ from
// the corresponding z-indexes defined by Stencil.  Because of this, the default Flyout component
// in Stencil renders beneath the navbar defined in Bootstrap.  To fix this, we'll adjust some of
// the Stencil z-indexes:
//
// In Bootstrap V3 (https://github.com/twbs/bootstrap/blob/v3-dev/less/variables.less):
// @zindex-tooltip:           1070;
// @zindex-popover:           1060;
// @zindex-modal:             1050;
// @zindex-modal-background:  1040;
// @zindex-navbar-fixed:      1030;
// @zindex-dropdown:          1000;
// @zindex-navbar:            1000;
//
// In Stencil (https://code.amazon.com/packages/StencilReactThemeDefault/blobs/2.x/--/src/index.ts):
// zIndex: {
//   highest: 1000,
//   modal: 900,
//   flyout: 800,
//   header: 700,
//   stickyContent: 650,
//   sideMenu: 600,
//   dropdown: 500,
//   popover: 400,
//   alert: 300,
// },
//
// To maintain relative z-indexes after the Stencil Flyout is adjusted, we'll also update a few
// others:
//
// Flyout  = 1035 (Must be larger than Bootstrap header (1000) and fixed header (1030))
// Modal   = 1050 (Must be larger than Flyout, but match Bootstrap modal (1050))
// Highest = 1500 (Must be larger than Modal.
export default function ThemeProvider({ children }) {
    const customTheme = Object.assign({}, AtoZTheme);
    customTheme.zIndex.flyout = 1035;
    customTheme.zIndex.modal = 1050;
    customTheme.zIndex.highest = 1500;
    // Pass the current language into StencilProvider. For RTL languages, it adjusts padding,
    // margins, and other properties on some components.
    const { i18n } = useTranslation();
    return (React.createElement(StencilProvider, { theme: customTheme, locale: i18n.language }, children));
}
//# sourceMappingURL=ThemeProvider.js.map